import Button from "../../st-button/st-button";
import Dropdown from "../../st-dropdown/st-dropdown";
import { requireViewContext } from "../st-view";

export function ActionArea() {
    const viewCtx = requireViewContext();

    return (
        <div>
            <Dropdown>
                <Dropdown.Trigger as={Button}>
                    <i class='fa fa-bars'></i>
                </Dropdown.Trigger>
                {viewCtx.definition?.actionArea.menu.label}
                {/* <div style='max-height: 500px; max-width: 600px; overflow-y: auto;'>
                    {JSON.stringify(viewCtx.definition?.actionArea.menu)}
                </div> */}
                This is a test
            </Dropdown> 
        </div>
    )
}